export class PermissionError extends Error {
	code = 'permission_denied'

	constructor() {
		super('Permission denied')
		this.name = 'PermissionError'
	}
}
